import { render, staticRenderFns } from "./AlreadyGrabbed.vue?vue&type=template&id=08d69308&scoped=true"
import script from "./AlreadyGrabbed.vue?vue&type=script&lang=js"
export * from "./AlreadyGrabbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d69308",
  null
  
)

export default component.exports